import { POST_DRAFT_REPORT_ERROR } from './';

export default error => dispatch =>
  dispatch({ type: POST_DRAFT_REPORT_ERROR, payload: { error } });
